import { SUPPORT_CONTACT } from "../../const/AppConst";
import MgpButton from "../../elements/MgpButton/MgpButton";

interface SubscriptionEndComponentProps {
  subscriptionUrl: string
}

export default function SubscriptionEndComponent({subscriptionUrl} : SubscriptionEndComponentProps) {

  const handleClick = () => {
     window.location.href = subscriptionUrl;
  }

  return (             
    <form style={{width: '100%', textAlign: "justify"}}>
      
      <p className="card-title bleu mb-md">Votre identification est finalisée</p>    
  
      {/* <p className='text'>Le lien d'accès à votre parcours personnalisé d'affiliation vient de vous être envoyé par email.</p>
      <p className='text mb-lg'>Vous pouvez y accéder dès à présent pour finaliser votre affiliation, ajouter vos ayants droit et renforcer votre niveau de couverture selon vos besoins.</p> */}

      <p className='text mb-lg'>Vous pouvez accéder à votre parcours personnalisé d'affiliation dès à présent pour finaliser votre affiliation, ajouter vos ayants droit et renforcer votre niveau de couverture selon vos besoins.</p>

      <p className='bg-bleu-clair-15 p-xs flex va-center jc-start mt-lg' style={{flexWrap: "unset"}}>
        <i className='icon-info'></i><span>La finalisation de votre parcours d'affiliation est indispensable pour percevoir vos remboursements.</span>
      </p>
        

      <div className='form-row jc-right mt-xl'>
        <MgpButton
            id="submitButton"
            type="button"
            text= {"J'accède à mon parcours d'affiliation"}
            icon='chevron-right'
            iconPosition="right"
            onClick={handleClick}
        ></MgpButton>
        
      </div>

      <a className="bleu link mt-lg hide-in-desktop" href={`tel:${SUPPORT_CONTACT}`}>Besoin d'aide ?</a>
        
    </form>
  )
}
